import { render, staticRenderFns } from "./reportFeeDetailRoom.vue?vue&type=template&id=bb01274a&scoped=true"
import script from "./reportFeeDetailRoom.vue?vue&type=script&lang=js"
export * from "./reportFeeDetailRoom.vue?vue&type=script&lang=js"
import style0 from "./reportFeeDetailRoom.vue?vue&type=style&index=0&id=bb01274a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb01274a",
  null
  
)

export default component.exports